module.exports = __webpack_public_path__ + "img/overload.fa8c97bb.svg";